module.exports = __webpack_public_path__ + "img/img-hotrod-d.a1946470.png";